export default {
  checkEmpty: checkEmpty,									// 判断单个值是否为空，是空传回 true
  checkKong: checkKong,                   // 判断单个值是否为空，是空传回 true 不做0验证
  checkListEmpty: checkListEmpty, 				// 判断数组值是否为空，数组的长度 true
  checkEmptyTrim: checkEmptyTrim,         // 判断值是否为空,去掉空格是否为空 true
  trimSpace: trimSpace,                   // 去除数组为空的字段
  cloneObj: cloneObj,                     // 深度克隆对象
  getUrlParamValue: getUrlParamValue,     // 根据URL获取参数
  ntime: ntime,                           // 获取当前时间
  dtime: dtime,                           // 时间戳转换成时间
  mtime: mtime,                           // 往后顺延月份
  ctime: ctime,                           // 指定日期距离当前日期差
  isIdentityId: isIdentityId,             // 身份证的校验
  reditCode: reditCode,                   // 统一社会信用代码
  fomatQh: fomatQh,                       // 效验地址的区划是否和选择的行政区划一致
  checkMail: checkMail,                   // 校验邮箱格式是否正确
}

/*  判断值是否为空  */
function checkEmpty(val) {
  if (val === undefined || val === null || (val === '' && val !== 0)) {
    return true
  }
  return false
}

/*  判断值是否为空  */
function checkKong(val) {
  if (val === undefined || val === null || val === '') {
    return true
  }
  return false
}

/*  判断值是否为空  */
function checkEmptyTrim(val) {
  if (val === undefined || val === null || (val === '' && val !== 0)) {
    return true
  }
  val = val.replace(/(^\s*)|(\s*$)/g, "");
  if (val === null || (val === '' && val !== 0)) {
    return true
  }
  return false
}

/*  判断数组的长度  */
function checkListEmpty(val) {
  if (val === undefined || val === null) {
    return true
  }
  if (val.length < 1) {
    return true
  }
  return false
}

/*  去除数组为空的字段  */
function trimSpace(array) {
  for (var i = 0; i < array.length; i++) {
    if (array[i] == "" || array[i] == null || typeof (array[i]) == "undefined") {
      array.splice(i, 1);
      i = i - 1;
    }
  }
  let array1 = [...new Set(array)]
  return array1;
}

/* 深度拷贝对象 */
function cloneObj(obj) {
  var str; var newobj = obj.constructor === Array ? [] : {}
  if (typeof obj !== 'object') {
    return
  } else if (window.JSON) {
    str = JSON.stringify(obj), // 序列化对象
      newobj = JSON.parse(str) // 还原
  } else {
    for (var i in obj) {
      newobj[i] = typeof obj[i] === 'object' ? cloneObj(obj[i]) : obj[i]
    }
  }
  return newobj
}

/*
*根据URL获取参数
*/
function getUrlParamValue(url, paramName) {
  if (url.indexOf('?') < 1) {
    return null
  }
  const paramStr = url.substr(url.indexOf('?') + 1)
  const paramList = paramStr.split('&')
  if (this.checkListEmpty(paramList)) {
    return null
  }
  let currParamStr = ''
  let currParamList = null
  let currKey = ''
  let currValue = ''
  for (let cnt = 0; cnt < paramList.length; cnt++) {
    currParamStr = paramList[cnt]
    if (this.checkEmpty(currParamStr)) {
      continue
    }
    if (currParamStr.indexOf('=') < 1) {
      continue
    }
    currParamList = currParamStr.split('=')
    if (this.checkListEmpty(currParamStr)) {
      continue
    }
    if (currParamList.length != 2) {
      continue
    }
    currKey = currParamList[0]
    currValue = currParamList[1]
    if (currKey == paramName) {
      return currValue
    }
  }
  return null
}

/** 获取当前时间
 * @param fmt {boolean} ture(yyyy - MM - dd) ; false(yyyy - MM - dd hh: mm) 
 **/
function ntime(fmt = true) {
  let myDate = new Date();
  let newtime = ''
  if (fmt) {
    newtime = myDate.getFullYear() + "-" + (myDate.getMonth() + 1 < 10 ? '0' + (myDate.getMonth() + 1) : myDate.getMonth() + 1) + '-' + "-" + (myDate.getDate() < 10 ? '0' + (myDate.getDate()) : myDate.getDate())
  } else {
    newtime = myDate.getFullYear() + "-" + (myDate.getMonth() + 1 < 10 ? '0' + (myDate.getMonth() + 1) : myDate.getMonth() + 1) + '-' + "-" + (myDate.getDate() < 10 ? '0' + (myDate.getDate()) : myDate.getDate()) + " " + myDate.getHours() + ":" + myDate.getMinutes() + ":" + myDate.getSeconds();
  }
  return newtime
}

/** 时间戳转换成时间
 * @param fmt {boolean} -ture(yyyy - MM - dd) ; false(yyyy - MM - dd hh: mm) 
 * @param inputTime { Number } -必选 需要转换的时间戳
 **/
function dtime(inputTime, fmt = true) {
  var datetime = new Date(inputTime)
  let Ytime = datetime.getFullYear() + '-';
  let Mtime = (datetime.getMonth() + 1 < 10 ? '0' + (datetime.getMonth() + 1) : datetime.getMonth() + 1) + '-';
  let Dtime = (datetime.getDate() < 10 ? '0' + (datetime.getDate()) : datetime.getDate());
  let htime = (datetime.getHours() < 10 ? '0' + (datetime.getHours()) : datetime.getHours()) + ':';
  let mtime = (datetime.getMinutes() < 10 ? '0' + (datetime.getMinutes()) : datetime.getMinutes()) + ':';
  let stime = (datetime.getSeconds() < 10 ? '0' + (datetime.getSeconds()) : datetime.getSeconds());
  let newtime = ""
  if (fmt) {
    newtime = newtime + Ytime + Mtime + Dtime;
  } else {
    newtime = newtime + Ytime + Mtime + Dtime + " " + htime + mtime + stime;
  }
  return newtime;
}

/** 往后顺延月份
 * @param time {boolean} -ture(yyyy - MM - dd)
 * @param 
 **/
function mtime(time) {
  // 获取当前日期
  const currentDate = new Date(time);
  // 获取当前日期的年份、月份和日期
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();
  const currentDay = currentDate.getDate();
  // 计算往后顺延 6 个月后的日期
  const targetYear = currentYear + Math.floor((currentMonth + 6) / 12);
  const targetMonth = (currentMonth + 6) % 12;
  const targetDay = Math.min(currentDay, new Date(targetYear, targetMonth + 1, 0).getDate());
  // 拼接日期字符串
  const dateString = `${targetYear}-${String(targetMonth + 1).padStart(2, '0')}-${String(targetDay).padStart(2, '0')}`;
  return dateString;
}

/** 指定日期距离当前日期差
 * @param time {boolean} -ture(yyyy - MM - dd)
 * @param 
 **/
function ctime(time) {
  console.log(time)
  // 指定日期
  const specifiedDate = new Date(time);
  // 当前日期
  const currentDate = new Date();
  // 计算两个日期之间的毫秒数差异
  const timeDiff = specifiedDate.getTime() - currentDate.getTime();
  // 将毫秒数转换为天数
  const dayDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
  return dayDiff;
}

/* 身份证校验 */
function isIdentityId(identityId) {
  var patrn = /(^\d{15}$)|(^\d{17}(\d|X|x)$)/;//长度或格式校验
  //地区校验
  var aCity = {
    11: "北京",
    12: "天津",
    13: "河北",
    14: "山西",
    15: "内蒙古",
    21: "辽宁",
    22: "吉林",
    23: "黑龙江",
    31: "上海",
    32: "江苏",
    33: "浙江",
    34: "安徽",
    35: "福建",
    36: "江西",
    37: "山东",
    41: "河南",
    42: "湖北",
    43: "湖南",
    44: "广东",
    45: "广西",
    46: "海南",
    50: "重庆",
    51: "四川",
    52: "贵州",
    53: "云南",
    54: "西藏",
    61: "陕西",
    62: "甘肃",
    63: "青海",
    64: "宁夏",
    65: "新疆",
    71: "台湾",
    81: "香港",
    82: "澳门",
    91: "国外"
  };
  // 出生日期验证
  var sBirthday = (
    identityId.substr(6, 4) +
    "-" +
    Number(identityId.substr(10, 2)) +
    "-" +
    Number(identityId.substr(12, 2))
  ).replace(/-/g, "/"),
    d = new Date(sBirthday)

  // 身份证号码校验 最后4位  包括最后一位的数字/字母X
  var sum = 0,
    weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2],
    codes = "10X98765432";
  for (var i = 0; i < identityId.length - 1; i++) {
    sum += identityId[i] * weights[i];
  }
  var last = codes[sum % 11]; //计算出来的最后一位身份证号码
  console.log(last)
  var errorMsg = true;
  if (identityId === '') {
    errorMsg = "身份证号不能为空"
  } else if (!patrn.exec(identityId)) {
    errorMsg = "你输入的身份证长度或格式错误"
  } else if (!aCity[parseInt(identityId.substr(0, 2))]) {
    errorMsg = "你的身份证地区非法"
  } else if (sBirthday != d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate()) { errorMsg = "身份证上的出生日期非法" } else if (identityId[identityId.length - 1] != last) {
    errorMsg = "你输入的身份证号非法"
  }
  return errorMsg;
}

/* 统一社会信用代码 */
function reditCode(val) {
  if (val.length == 15 || val.length == 18) {
    return true
  }
  return false
}

/**
 * 效验地址的区划是否和选择的行政区划一致（34个行政区划，注意如新疆生产建设兵团这种特殊区划）
 * @param {Object} quhua 传入值区划名称，
 */
function fomatQh(quhua) {
  var addr = quhua.toString();
  if (addr === undefined || addr === null || (addr === '' && addr !== 0)) {
    return true
  }
  if (addr.indexOf("(") > -1) {
    addr = addr.replace("(", "（");
  }
  if (addr.indexOf(")") > -1) {
    addr = addr.replace(")", "）");
  }
  var ary = new Array('北京市', '天津市', '河北省', '山西省', '内蒙古自治区', '内蒙古省', '辽宁省', '吉林省', '黑龙江省', '上海市', '江苏省', '浙江省', '安徽省', '福建省', '江西省', '山东省', '河南省', '湖北省', '湖南省', '广东省', '广西壮族自治区', '广西省', '海南省', '重庆市', '四川省', '贵州省', '云南省', '西藏自治区', '西藏省', '陕西省', '甘肃省', '青海省', '宁夏回族自治区',
    '宁夏省', '新疆维吾尔自治区', '新疆省', '香港特别行政区', '香港', '中国香港', '澳门特别行政区', '中国澳门', '澳门', '台湾省', '中国台湾', '台湾', '新疆生产建设兵团', '中国（上海）自由贸易试验区', '中国（广东）自由贸易试验区', '中国（天津）自由贸易试验区', '中国（福建）自由贸易试验区', '中国（辽宁）自由贸易试验区', '中国（浙江）自由贸易试验区', '中国（河南）自由贸易试验区', '中国（湖北）自由贸易试验区', '中国（重庆）自由贸易试验区', '中国（四川）自由贸易试验区', '中国（陕西）自由贸易试验区',
    '中国（山东）自由贸易试验区', '中国（江苏）自由贸易试验区', '中国（广西）自由贸易试验区', '中国（河北）自由贸易试验区', '中国（云南）自由贸易试验区', '中国（黑龙江）自由贸易试验区', '中国（北京）自由贸易试验区', '中国（湖南）自由贸易试验区', '中国（安徽）自由贸易试验区', '中国（海南）自由贸易试验区');
  for (var i = 0; i < ary.length; i++) {
    if (addr.substr(0, 13).indexOf(ary[i]) > -1) {
      return false
    }
  }
  return false
}

/*  校验邮箱格式是否正确  */
function checkMail(val) {
  var reg = /^[A-Za-z0-9_\.]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
  if (reg.test(val)) {
    return false
  } else {
    return true
  }
}